import React from "react";
import withStyles from '@mui/styles/withStyles';
import arrow from "../../assets/images/arrow.png";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { BUY_COUPON } from "../../queries/mutations";

const button = {
  boxShadow: "0px 3px 20px #00000026",
  fontSize: "16px",
  fontWeight: "bold",
  textTransform: "uppercase",
  padding: "16px 30px",
  color: "#FFFFFF",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const styles = (theme) => ({
  block: {
    position: "fixed",
    bottom: "0px",
    background: "transparent linear-gradient(180deg, #FFFFFF 0%, #F0F0F2 100%)",
    boxShadow: "0px 3px 20px #38383833",
    height: "84px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "80px",
  },
  buttonDisabled: {
    ...button,
    background: "#b7b7b796",
  },
  button: {
    ...button,
    background: "#7FC5ED 0% 0%",
  },
  arrow: {
    marginLeft: "9px",
  },
});

const BoughtControl = ({ campaignId, classes, disabled }) => {
  const history = useHistory();
  const [buyCouponMutation] = useMutation(BUY_COUPON, {
    onCompleted({ buyCoupon: { isSuccess } }) {
      if (isSuccess) {
        history.push(`/successful-purchase/${campaignId}`);
      }
    },
    onError: (data) => {
      console.log("error", data);
    },
  });
  const buyCoupon = (campaignId) => {
    buyCouponMutation({ variables: { campaignId: campaignId } });
  };

  return (
    <div className={classes.block}>
      <div
        className={disabled ? classes.buttonDisabled : classes.button}
        onClick={(e) => buyCoupon(campaignId)}
      >
        <span>Coupon kaufen</span>
        <img className={classes.arrow} src={arrow} alt="" />
      </div>
    </div>
  );
};
export default withStyles(styles)(BoughtControl);
